import {
  apiClient,
  type PartnerUserExEntity,
  type PageEntity
} from '@/libs/api'
import { type PartnerUsersRequestQuery } from '@/libs/api/types'

export type FetchPartnerUsersListQuery = {
  tenantKey: string
  query?: PartnerUsersRequestQuery
}

export type FetchPartnerUsersListResponse = {
  data: PartnerUserExEntity[]
  pagination: PageEntity | null
}

export const fetchPartnerUsers = async (
  { tenantKey, query }: FetchPartnerUsersListQuery,
  signal?: AbortSignal
): Promise<FetchPartnerUsersListResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .partner_users.$get({
      query,
      config: {
        signal
      }
    })
  return { data, pagination }
}
